import React from "react";
import { Table } from "antd";

const MedecinsTable = ({ medecins, columns, onRow }) => {
  return (
    <Table 
      dataSource={medecins} 
      columns={columns} 
      rowKey="key"
      onRow={onRow}
    />
  );
};

export default MedecinsTable; 